import { Component, Input, OnInit } from '@angular/core'
import { NaturalStoneColor } from '../../../interfaces/natural-stone/natural-stone-color'
import { DomSanitizer, SafeUrl } from '@angular/platform-browser'
import { ButtonComponent } from '@components/button/button.component'
import { TranslateModule } from '@ngx-translate/core'
import { NgIf, NgOptimizedImage } from '@angular/common'
import { NaturalStoneService } from '../../../services/natural-stone.service'
import { Router } from '@angular/router'
import { environment } from '../../../../environments/environment'

@Component({
  selector: 'app-natural-stone-color-card',
  standalone: true,
    imports: [
        ButtonComponent,
        TranslateModule,
        NgOptimizedImage,
        NgIf,
    ],
  templateUrl: './natural-stone-color-card.component.html',
  styleUrl: './natural-stone-color-card.component.scss'
})
export class NaturalStoneColorCardComponent implements OnInit{
    @Input() color!: NaturalStoneColor;
    @Input() index!: number;

    imageUrl: SafeUrl;
    currentImageUrl: string;
    colorText?: string;
    brandText?: string;

    constructor(
        private sanitizer: DomSanitizer,
        private naturalStoneService: NaturalStoneService,
        private router: Router
    ) {
    }

    ngOnInit() {
        if(this.color.imageUrl && this.color.imageUrl.startsWith('https')){
            this.imageUrl = this.sanitizer.bypassSecurityTrustUrl(this.color.imageUrl + "?width=300") //NOSONAR
            this.currentImageUrl = this.color.imageUrl
        } else {
            this.imageUrl = "assets/images/processing-image.png"
            this.currentImageUrl = "assets/images/processing-image.png"
        }
        this.setupBrandText()
        this.setupColorText()
    }

    onImageError(){
        if(this.currentImageUrl && this.currentImageUrl.includes(`/${this.color.colorCode!}/`) && this.color.firstLotId){
            let imageUrl = environment.lotImageCdn.replace('{lotId}', this.color.firstLotId)
            this.imageUrl = this.sanitizer.bypassSecurityTrustUrl(imageUrl) //NOSONAR
            this.currentImageUrl = imageUrl
        } else if(this.currentImageUrl && this.color.firstLotId && this.currentImageUrl.includes(this.color.firstLotId)) {
            this.imageUrl = "assets/images/processing-image.png"
            this.currentImageUrl = "assets/images/processing-image.png"
        }
    }

    setupBrandText(){
        if(this.color.brand){
            this.brandText = this.color.brand[0].toUpperCase() + this.color.brand.substring(1).toLowerCase()
        }
    }

    setupColorText(){
        const name = this.color.colorName
        if(!name){
            this.colorText = this.color.colorCode
            return;
        }
        const capitalizedWords = name.split(' ').map((word) => {
            if(word.length > 1){
                return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
            } else if(word.length === 1){
                return word.toUpperCase()
            } else {
                return word
            }
        })
        this.colorText = capitalizedWords.join(' ')
    }

    goToLotsForColor(){
        this.naturalStoneService.selectColor(this.color)
        const selectedColor = this.naturalStoneService.selectedColor()
        if(this.naturalStoneService.selectedCenter() && selectedColor.sku){
            this.router.navigate(['natural-stone', 'lots', this.naturalStoneService.selectedCenter(), this.naturalStoneService.selectedColor().sku])
        }
    }

}
